/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_Replace_LabelInputs */



/**
* | output |
* | --- |
* | "Replace" |
*
* @param {Marker_Import_Replace_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_replace_label = /** @type {((inputs?: Marker_Import_Replace_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_Replace_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Remplacer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ersetzen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sostituire")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Заменять")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reemplazar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("代替")
	if (locale === "ja") return /** @type {LocalizedString} */ ("交換する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रतिस्थापित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Substituir")
	return /** @type {LocalizedString} */ ("Replace")
});